import { mutualLinkStyle } from '@/decodo/blocks/Footer';
import LinkButtonStrapi, {
  LinkButtonStrapiProps,
} from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import { Text } from '@/decodo/components/atoms/Text';

type FooterCategory = {
  title: string;
  links: LinkButtonStrapiProps[];
};

export type FooterCategoriesProps = {
  categories: FooterCategory[];
};

const FooterCategories = ({ categories }: FooterCategoriesProps) => (
  <div className='flex flex-1 flex-wrap gap-10 md:gap-[60px]'>
    {categories.map((category, index) => (
      <div key={index} className='flex w-[200px] flex-col gap-6'>
        <Text
          variant='label-medium'
          classNames={{
            wrapper:
              'font-mono uppercase text-gray-500 dark:text-gray-dark-400',
          }}
        >
          {category.title}
        </Text>
        <div className='flex flex-col gap-3'>
          {category.links.map((link, index) => (
            <LinkButtonStrapi
              key={index}
              block={link}
              inner={{
                classNames: {
                  root: mutualLinkStyle,
                },
                slim: true,
                textWrap: true,
                variant: 'text',
                underline: false,
                color: 'tertiary',
              }}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default FooterCategories;
